<template>
  <b-modal
    id="modal-progress-edit"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    centered
    body-class="common_modal modal_visible"
    hide-footer
    no-close-on-backdrop
    size="lg"
    hide-header-close
  >
    <modal-stage-info
      :infoData="infoData"
      @refetch-data="$emit('refetch-data')"
    />

    <template #modal-header="{ close }">
      <h3 class="m-0">
        <font-awesome-icon class="mr-50" icon="fa-solid fa-clock" />更新進度
      </h3>
      <a @click="close()">
        <font-awesome-icon style="font-size: 20px" icon="fas fa-times" />
      </a>
    </template>

    <div>
      <a class="addButton" href="javascript:void(0)" @click="addItem">
        <feather-icon size="20" icon="PlusIcon"></feather-icon>
      </a>
      <a
        class="removeButton mr-2"
        href="javascript:void(0)"
        @click="removeItem(selected_item, newProgressList[selected_item].id)"
      >
        <feather-icon size="20" icon="MinusIcon"></feather-icon>
      </a>
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <div
          class="time-line-group d-flex flex-wrap align-items-end justify-content-between"
        >
          <div class="group">
            <app-timeline class="horizontal mt-3">
              <app-timeline-item
                :icon="
                  item.is_completed
                    ? '@/assets/images/icons/tick.png'
                    : '@/assets/images/icons/question.png'
                "
                :class="[
                  item.is_completed ? 'active' : '',
                  selected_item === index ? 'selected' : '',
                ]"
                v-for="(item, index) in newProgressList"
                :key="`progress_item_${item.id}_${index}`"
                @click="selected_item = index"
              >
                <div
                  class="timeline-item-content"
                  :class="item.is_completed ? 'active' : null"
                >
                  <div class="text mb-50">
                    {{ item.name }}
                  </div>
                  <div>
                    {{ item.complete_date }}
                  </div>
                </div>
              </app-timeline-item>
            </app-timeline>
          </div>
        </div>
        <hr />
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-form class="mt-1" @submit.prevent="handleSubmit(onSubmit)">
            <b-row>
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_name"
                >
                  <b-form-group
                    label="進度名稱："
                    label-for="name"
                    label-cols-md="3"
                  >
                    <b-form-input
                      id="name"
                      v-model="newProgressList[selected_item].name"
                      placeholder="輸入進度名稱"
                      :state="getValidationState(validationContext)"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <!-- <validation-provider
                  #default="validationContext"
                  name="完工日期"
                  rules="required"
                > -->
                <b-form-group
                  label="完工日期："
                  label-for="complete_date"
                  label-cols-md="3"
                  vid="v_complete_date"
                >
                  <flat-pickr
                    v-model="newProgressList[selected_item].complete_date"
                    class="form-control"
                    :config="{
                      allowInput: true,
                      altInput: true,
                      altFormat: 'Y-m-d',
                      dateFormat: 'Y-m-d',
                    }"
                    placeholder="輸入YYYY-MM-DD"
                  />

                  <!-- <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback> -->
                </b-form-group>
                <!-- </validation-provider> -->
              </b-col>
              <!-- active -->
              <b-col cols="12" md="6">
                <b-form-group
                  label="是否完成："
                  label-for="content"
                  label-cols-md="3"
                  vid="v_is_completed"
                >
                  <b-form-checkbox
                    :checked="newProgressList[selected_item].is_completed"
                    switch
                    inline
                    v-model="newProgressList[selected_item].is_completed"
                    value="1"
                    style="margin-top: 5px"
                  >
                    {{
                      newProgressList[selected_item].is_completed
                        ? "完成"
                        : "未完成"
                    }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
              <!-- sort_order -->
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_sort_order"  
                >
                  <b-form-group
                    label="排序："
                    label-for="sort_order"
                    label-cols-md="3"
                  >
                    <b-form-input
                      type="number"
                      id="sort_order"
                      v-model="newProgressList[selected_item].sort_order"
                      placeholder="輸入排序"
                      :state="getValidationState(validationContext)"
                    />

                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
            </b-row>
            <div class="d-flex mt-2 justify-content-end">
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-danger"
                class="mr-1"
                @click="hide"
              >
                取消
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                type="submit"
              >
                <font-awesome-icon
                  class="mr-25"
                  icon="fa-solid fa-circle-check"
                />
                提交
              </b-button>
            </div>
          </b-form>
          <div v-if="newProgressList[selected_item].id > 0">
            <hr />
            <div class="d-flex aling-items-center justify-content-between">
              <h5 class="d-flex align-items-center">進度詳情</h5>
              <div class="d-flex align-items-center mb-1">
                <b-button
                  variant="primary"
                  class="d-flex py-50 px-2 align-items-center"
                  @click="addInfoItem(newProgressList[selected_item].id)"
                >
                  <feather-icon icon="PlusIcon" size="20" />
                  新增
                </b-button>
              </div>
            </div>
            <div>
              <b-row
                v-for="(info, index) in newProgressList[selected_item].info"
                :key="`info_${newProgressList[selected_item].id}_${info.id || 'new'}_${index}`"
                class="px-1"
              >
                <b-col
                  cols="12"
                  class="d-flex backgroundColor3 mb-1 radius-round border-1"
                >
                  <b-row class="flex-grow-1 p-2">
                    <!-- product id -->

                    <b-row>
                      <b-col cols="12" md="6">
                        <validation-provider
                          #default="validationContext"
                          :vid="`v-project_stage_info-date${selected_item}_${info.id || 'new'}_${index}`"
                          name="此欄"
                          rules="required"
                        >
                          <b-form-group
                            :label="`日期：`"
                            :label-for="`project_stage_info-date${index}`"
                            label-cols-md="3"
                            class="required"
                          >
                          <!-- disabled -->
                            <flat-pickr
                              v-model="info.info_date"
                              class=""
                              :config="{
                                allowInput: true,
                                altInput: true,
                                altFormat: 'Y-m-d',
                                dateFormat: 'Y-m-d',
                              }"
                              placeholder="輸入YYYY-MM-DD"
                            />
                            <b-form-invalid-feedback
                              :state="getValidationState(validationContext)"
                            >
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>

                      <b-col cols="12" md="6">
                        <validation-provider
                          #default="validationContext"
                          :vid="`v-project_stage_info-title${selected_item}_${info.id || 'new'}_${index}`"
                          name="此欄"
                          rules="required"
                        >
                          <b-form-group
                            label="主題："
                            label-for=""
                            label-cols-md="3"
                          >
                          <!-- disabled -->
                            <b-form-input
                              v-model="info.title"
                              placeholder="輸入主題"
                              :state="getValidationState(validationContext)"
                            />
                            <b-form-invalid-feedback>
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>

                      <b-col cols="12" md="6">
                        <validation-provider
                          #default="validationContext"
                          :vid="`v-project_stage_info-description${selected_item}_${info.id || 'new'}_${index}`"
                          name="此欄"
                          rules="required"
                        >
                          <b-form-group
                            label="內容："
                            label-for=""
                            label-cols-md="3"
                          >
                          <!-- disabled -->
                            <b-form-input
                              v-model="info.description"
                              placeholder="輸入內容"
                              :state="getValidationState(validationContext)"
                            />
                            <b-form-invalid-feedback>
                              {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>
                          </b-form-group>
                        </validation-provider>
                      </b-col>
                      <b-col cols="12">
                         <upload-file
                          :key="`stage_info_${newProgressList[selected_item].id}_${info.id || 'new'}_${index}`"
                          :custome_id="`stage_info_${newProgressList[selected_item].id}_${info.id || 'new'}_${index}`"
                          :props_previewImage="info.files"
                          v-on:file-uploaded="(file)=>onFileUploaded(file, info)"
                          file_delete_url="/project_stages/info/files"
                        ></upload-file>
                      </b-col>
                      <b-col cols="12" class="d-flex justify-content-end">
                        <b-button variant="primary" @click="onStageInfoSubmit(info)">
                          提交
                        </b-button>
                      </b-col>

                    </b-row>
                  </b-row>
                  <div
                    class="d-flex flex-column justify-content-between py-50 px-25"
                  >
                    <feather-icon
                      size="16"
                      icon="XIcon"
                      class="cursor-pointer text-danger"
                      @click="removeInfoItem(index, info.id)"
                    />
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-overlay>
      </validation-observer>
    </div>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import store from "@/store";
import { required } from "@validations";
import { ref, watch, onUnmounted } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import ModalStageInfo from "./ModalStageInfo.vue";
import uploadFile from "@/layouts/components/file/uploadFile.vue";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BRow,
    BCol,
    BCardBody,
    BCard,
    BFormInvalidFeedback,
    AppTimeline,
    AppTimelineItem,
    vSelect,
    flatPickr,
    ModalStageInfo,
    uploadFile,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    project_id: {},
    progressList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      required,
      selected_item: 0,
      infoData: { id: 0 },
    };
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-progress-edit");
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
    onFileUploaded(files, info) {
      // 僅保存新上傳文件，避免覆蓋既有的服務端文件清單
      info.upload_files = files;
    },
    deleteRecord(id, apiKey) {
      this.$swal({
        title: "你確定嗎?",
        text: "您的行動是最終的，您將無法檢索項目記錄。",
        showCancelButton: true,
        confirmButtonText: "刪除",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch(`order/${apiKey}`, { id: id })
            .then((response) => {
              this.$swal({
                text: response.data.message,
                icon: "success",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
            })
            .catch((error) => {
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          const data = {
            project_id: this.project_id,
            stages: this.newProgressList,
          };
          store
            .dispatch("order/editProjectStage", data)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    onStageInfoSubmit(item) {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          const formData = new FormData();  
          formData.append("id", item.id);
          formData.append("project_stage_id", this.newProgressList[this.selected_item].id);
          formData.append("info_date", item.info_date);
          formData.append("title", item.title);
          formData.append("description", item.description);
          const uploadFiles = item.upload_files || [];
          if (uploadFiles && uploadFiles.length > 0) {
            uploadFiles.forEach((f) => {
              formData.append("image_files[]", f);
            });
          }
          store
            .dispatch("order/editProjectStageInfo", formData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
    addItem() {
      // this.newProgressList.forEach((o) => Number(o.sort_order + 1));
      this.newProgressList.push({
        id: 0,
        complete_date: null,
        is_completed: 0,
        sort_order: 0,
      });
      this.selected_item =
        this.selected_item >= this.newProgressList.length - 1
          ? 0
          : this.selected_item + 1;
    },
    removeItem(index, id) {
      // check number of record
      let record = this.newProgressList && this.newProgressList.length;
      if (record <= 1) {
        this.makeToast("danger", "Warning", "請至少留有一個表單。");
      } else {
        if (id > 0) {
          this.$swal({
            title: "你確定嗎?",
            text: "您的行動是最終的，您將無法檢索這記錄。",
            showCancelButton: true,
            confirmButtonText: "刪除",
            cancelButtonText: "取消",
            customClass: {
              confirmButton: "btn btn-primary",
              cancelButton: "btn btn-outline-danger ml-1",
            },
            buttonsStyling: false,
          }).then((result) => {
            if (result.value) {
              store
                .dispatch("order/deleteProjectStage", { id })
                .then((response) => {
                  this.$swal({
                    text: response.data.message,
                    icon: "success",
                    confirmButtonText: "確定",
                    customClass: {
                      confirmButton: "btn btn-primary",
                    },
                    showClass: {
                      popup: "animate__animated animate__bounceIn",
                    },
                    buttonsStyling: false,
                  });
                  this.selected_item =
                    this.selected_item <= 1 ? 0 : this.selected_item - 1;
                  this.$emit("refetch-data");
                })
                .catch((error) => {
                  this.$swal({
                    text: error.response.data.message,
                    icon: "error",
                    confirmButtonText: "確定",
                    customClass: {
                      confirmButton: "btn btn-primary",
                    },
                    showClass: {
                      popup: "animate__animated animate__bounceIn",
                    },
                    buttonsStyling: false,
                  });
                });
            }
          });
        } else {
          this.newProgressList.splice(index, 1);
          this.selected_item =
            this.selected_item <= 1 ? 0 : this.selected_item - 1;
        }
      }
    },
    addInfoItem(stage_id) {
      this.infoData = {
        id: 0,
        project_stage_id: stage_id,
      };
      this.$bvModal.show("modal-stage-info");
    },
    removeInfoItem(index, id) {
      // check number of record
      let record =
        this.newProgressList[this.selected_item].info &&
        this.newProgressList[this.selected_item].info.length;

      if (id > 0) {
        this.$swal({
          title: "你確定嗎?",
          text: "您的行動是最終的，您將無法檢索這記錄。",
          showCancelButton: true,
          confirmButtonText: "刪除",
          cancelButtonText: "取消",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result.value) {
            store
              .dispatch("order/deleteProjectStageInfo", { id })
              .then((response) => {
                this.$swal({
                  text: response.data.message,
                  icon: "success",
                  confirmButtonText: "確定",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  showClass: {
                    popup: "animate__animated animate__bounceIn",
                  },
                  buttonsStyling: false,
                });
                this.$emit("refetch-data");
              })
              .catch((error) => {
                this.$swal({
                  text: error.response.data.message,
                  icon: "error",
                  confirmButtonText: "確定",
                  customClass: {
                    confirmButton: "btn btn-primary",
                  },
                  showClass: {
                    popup: "animate__animated animate__bounceIn",
                  },
                  buttonsStyling: false,
                });
              });
          }
        });
      } else {
        this.newProgressList[this.selected_item].info.splice(index, 1);
      }
    },
  },
  setup(props) {
    const loading = ref(false);
    const newProgressList = ref([
      {
        id: 0,
        complete_date: null,
        is_completed: 0,
        sort_order: 0,
      },
    ]);

    const resetProgressList = () => {
      props.progressList = [
        JSON.parse(
          JSON.stringify({
            id: 0,
            complete_date: null,
            is_completed: 0,
            sort_order: 0,
          })
        ),
      ];
    };

    watch(
      () => props.progressList,
      (newVal) => {
        newProgressList.value =
          newVal && newVal.length > 0 ? [...newVal] : newProgressList.value;

        newProgressList.value.sort((a, b) => a.sort_order - b.sort_order);
      },
      { immediate: true }
    );

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetProgressList);

    return {
      loading,
      newProgressList,
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
#modal-progress-edit {
  .addButton,
  .removeButton {
    border-radius: 100%;
    width: 30px;
    aspect-ratio: 1/1;
    display: flex;
    float: right;
    justify-content: center;
    align-items: center;
    color: #fff;
  }
  .addButton {
    background: #42449b;
  }
  .removeButton {
    background: #ff0000;
  }
  // .time-line-group .app-timeline .timeline-item {
  //   &:nth-child(4n) {
  //     &:before {
  //       content: none;
  //     }
  //   }
  // }
}
</style>
